module.exports = __webpack_public_path__ + "img/homeSec03bg10.a61e9191.jpg";